// Checkbox gift

class CartCheckbox extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.input = this.querySelector('[data-checkbox-gift-input]');
		this.variantId = this.input.dataset.checkboxGiftVariantId;


		this.input.addEventListener('change', (event) => {
			var isChecked = event.target.checked;
			if (isChecked) {
				this.addItem(this.variantId);
			} else {
				this.updateItem(this.variantId);
			}
		});

		this.popup = this.querySelector('.checkbox-gift_popup');
		this.popupContent = this.querySelector('.checkbox-gift_popup-content');
		if (this.popup && this.popupContent) {
			this.popup.addEventListener('click', (event) => {
				this.togglePopup(event);
			});
		}
	}

	async addItem(variantId) {
		const item_properties = {
			'_gift_checkbox': true
		}

		if (this.input.dataset.hideLineItem !== undefined) {
			item_properties['_hide_line_item'] = true;
		}

		await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				id: variantId,
				quantity: 1,
				properties: item_properties
			})
		}).then((response) => {
			console.log(`[${this.id}]`, response);
			return response.text();
		})
			.catch((err) => {
				console.error(`[${this.id}]`, err)
			});
	}

	async updateItem(variantId) {
		await fetch("/cart/change", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				id: variantId,
				quantity: 0
			})
		}).then((response) => {
			console.log(response);
			return response.text();
		})
			.catch((err) => {
				console.error(err)
			});
	}

	togglePopup(event) {
		if (event.target === this.popup) {
			this.popupContent.classList.toggle('expanded');
		}
	}
}

customElements.get('cart-checkbox') || customElements.define('cart-checkbox', CartCheckbox);
